export const PART_SIMILARITY_MATCH_RESULT_CRITERIA = {
  EXACT_FILE: 'EXACT FILE',
  EXACT_GEOMETRIES: 'EXACT GEOMETRIES',
  FILENAME: 'MATCHING PART FILENAME',
  PART_NUMBER: 'MATCHING PART NUMBER',
  SIMILAR_GEOMETRIES: 'SIMILAR GEOMETRIES',
} as const;
